<template>
  <div class="c-outreach-contact-social-tweets">
    <OutreachContactTwitterEngagementMetrics
      :social-integration-id="socialIntegrationId"
      :twitter-username="twitterUsername"
      @set-twitter-handle="twitterHandle = $event"
      @set-twitter-user-id="twitterUserId = $event"
    />
    <OutreachContactTwitterPosts
      :scroll-target="scrollTarget"
      :social-integration-id="socialIntegrationId"
      :twitter-handle="twitterHandle"
      :twitter-user-id="twitterUserId"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";

import OutreachContactTwitterEngagementMetrics from "./OutreachContactTwitterEngagementMetrics.vue";
import OutreachContactTwitterPosts from "./OutreachContactTwitterPosts.vue";

defineProps({
  socialIntegrationId: {
    type: String,
    required: true,
  },
  twitterUsername: {
    type: String,
    required: true,
  },
  scrollTarget: {
    type: String,
    default: null,
  },
});

const twitterUserId = ref(null);
const twitterHandle = ref(null);
</script>

<style scoped lang="scss">
.c-outreach-contact-social-tweets {
  display: flex;
  flex-direction: column;
  row-gap: 18px;
  flex: 1;
  overflow: hidden;
  max-width: 700px;
  margin: auto;
  width: 100%;
}
</style>
